<div>
  <h3>{{'mfa.backupTitle' | translate}}</h3>
  <p>{{'mfa.backupText' | translate}}</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-input label="mfa.inputLabel" [formGroup]="form" name="code" [required]="true" />
      @if (failed) {
      <div class="error-message">
        <app-icon-warning />&nbsp;
        {{'mfa.invalidCode' | translate}}
      </div>
      }
    <label class="remember">
    <input type="checkbox" formControlName="remember">
    <span>{{'mfa.rememberDevice' | translate}}</span>
    </label>

    <div class="button-group">
      <div class="action">
        @if(loading) {
          <app-spinner></app-spinner>
        } @else {
          <app-button variant="accent">
            <button [disabled]="!form.valid" type="submit" data-testid="mfa-backup-submit">
              {{ 'mfa.submit' | translate }}
            </button>
          </app-button>
        }
      </div>

      <app-button>
        <a routerLink="/mfa" queryParamsHandling="preserve">{{'mfa.back' | translate}}</a>
      </app-button>
    </div>
  </form>
</div>
